module.exports = __webpack_public_path__ + "static/media/app-image.c0b55d5f.png";